import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./components/translation/en.json";
import th from "./components/translation/th.json";
import es from "./components/translation/es.json";
import id from "./components/translation/id.json";
import ar from "./components/translation/ar.json";
import vi from "./components/translation/vi.json";
import ms from "./components/translation/ms.json";
import fil from "./components/translation/fil.json";
import ko from "./components/translation/ko.json";
import ja from "./components/translation/ja.json";
import zh from "./components/translation/zh.json";
import hi from "./components/translation/hi.json";
import ta from "./components/translation/ta.json";
import mr from "./components/translation/mr.json";
import pt from "./components/translation/pt.json";
import fr from "./components/translation/fr.json";
import de from "./components/translation/de.json";
import it from "./components/translation/it.json";
import ru from "./components/translation/ru.json";
import { getStoredLanguage } from "./utils/getLanguage";
import { localizeBrand } from "./utils/brandTerms";

const lng = getStoredLanguage();

// Rewrites any legacy HealJai product name in translated strings to "Astria".
// Applied here so individual call sites don't each have to remember.
const brandPostProcessor = {
  type: "postProcessor" as const,
  name: "brand",
  process(
    value: string,
    _key: string | string[],
    options: { lng?: string },
    translator: { language?: string },
  ) {
    const branded = value
      .replace(/heal\s*jai/gi, "Astria")
      .replace(/ฮีลใจ/g, "Astria")
      .replace(/ฮีลเจย์/g, "Astria");
    // Then render the product terms natively for the active language.
    return localizeBrand(branded, options?.lng || translator?.language);
  },
};

i18n.use(brandPostProcessor).use(initReactI18next).init({
  resources: {
    en: { translation: en },
    th: { translation: th },
    es: { translation: es },
    id: { translation: id },
    ar: { translation: ar },
    vi: { translation: vi },
    ms: { translation: ms },
    fil: { translation: fil },
    ko: { translation: ko },
    ja: { translation: ja },
    zh: { translation: zh },
    hi: { translation: hi },
    ta: { translation: ta },
    mr: { translation: mr },
    pt: { translation: pt },
    fr: { translation: fr },
    de: { translation: de },
    it: { translation: it },
    ru: { translation: ru },
  },

  lng,
  fallbackLng: "en",

  interpolation: {
    escapeValue: false,
  },

  postProcess: ["brand"],
});

// Keep <html lang> in step with the UI language (screen readers, hyphenation,
// browser translate prompts). Direction is deliberately left alone: only the
// screens that were built for RTL set their own dir.
const syncDocumentLang = (language: string) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = language;
  }
};
syncDocumentLang(i18n.language);
i18n.on("languageChanged", syncDocumentLang);

export default i18n;
